import { TOKEN_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

export const isAuthenticated = () => !!getStorageItem<string | null>(TOKEN_KEY, null)
